import React from 'react';
import Icon from '../../../components/AppIcon';

const TopClientsPanel = ({ data = [], loading = false }) => {
  const formatCurrency = (value) => {
    return `$${value?.toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  };

  const getClientTypeLabel = (type) => {
    const labels = {
      'individual': 'Individual',
      'corporate': 'Corporativo',
      'fleet': 'Flotilla'
    };
    return labels?.[type] || type;
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <Icon name="TrendingUp" size={24} className="text-warning" />
        <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Top 10 Clientes por Valor de Vida (CLV)
        </h2>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <Icon name="Loader2" className="w-8 h-8 text-blue-600 animate-spin" />
        </div>
      ) : data?.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-64">
          <Icon name="UserX" size={48} className="text-muted-foreground mb-2" />
          <p className="text-sm caption text-muted-foreground">
            No hay datos de clientes disponibles
          </p>
        </div>
      ) : (
        <div className="space-y-3 max-h-96 overflow-y-auto scroll-smooth">
          {data?.map((client, index) => (
            <div
              key={client?.clientId}
              className="flex items-center justify-between p-3 rounded-lg border border-border hover:bg-muted/50 transition-smooth"
            >
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-primary/10">
                  {index === 0 && <Icon name="Trophy" size={20} className="text-warning" />}
                  {index === 1 && <Icon name="Medal" size={20} className="text-muted-foreground" />}
                  {index === 2 && <Icon name="Award" size={20} className="text-warning" />}
                  {index > 2 && <span className="text-sm font-semibold text-primary">#{index + 1}</span>}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <p className="text-sm font-medium text-foreground truncate">
                      {client?.clientName}
                    </p>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-primary/10 text-primary">
                      {getClientTypeLabel(client?.clientType)}
                    </span>
                  </div>
                  <div className="flex items-center gap-3 text-xs text-muted-foreground">
                    <span className="flex items-center gap-1">
                      <Icon name="Package" size={12} />
                      {client?.serviceCount} servicios
                    </span>
                    <span className="flex items-center gap-1">
                      <Icon name="DollarSign" size={12} />
                      Promedio: {formatCurrency(client?.averageInvoiceValue)}
                    </span>
                  </div>
                </div>
              </div>
              <div className="text-right">
                <p className="text-lg font-bold text-warning">
                  {formatCurrency(client?.clientLifetimeValue)}
                </p>
                <p className="text-xs text-muted-foreground">CLV</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TopClientsPanel;